import React from 'react';
import LegalLink from '../LegalLink';

// eslint-disable-next-line import/prefer-default-export
export const LEGAL_DISCLAIMER = (
  <>
    You&apos;re authorizing WebBank to issue you a DigniFi ExpressWay Credit Card.
    Clicking “Accept Offer” acknowledges my receipt and agreement to the
    {' '}
    <LegalLink href="https://www.dignifi.com/privacy-policy">
      Privacy Policy
    </LegalLink>
    ,
    {' '}
    <LegalLink href="https://www.dignifi.com/e-sign-disclosure">
      E-Sign Disclosure
    </LegalLink>
    {' '}
    and the
    {' '}
    <LegalLink href="https://app.dignifi.com/cardholder_agreement">
      WebBank DigniFi Credit Card Agreement
    </LegalLink>
    {' '}
    above. By finalizing this offer, I understand a hard inquiry will
    be placed on my credit report.
  </>
);
